module.exports = __webpack_public_path__ + "static/main_02-88456ae840e455b6d0e5ec4da50814b3.png";